import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';

export default class ChatGptUtilityFeedbackService extends BaseService {
  constructor() {
    super(constants.GET_CHATGPT_FEEDBACK_DATA, 'chatgptUtilityFeedbackStatus');
  }

  handleEvent(eventName, event) {
    return this.getClient('evergreen').post(`/userFeedback/table`, event.payload);
  }

  handleResponse(response) {
    const { data } = response;
    if (data.status === 'success') {
      Framework.getStoreRegistry().getStore('chatgptFeedbackUtility').setResponse(response.data);
    }
  }

  handleError(error) {
    // eslint-disable-line class-methods-use-this
    const bookStatus = Framework.getStoreRegistry().getStore('chatgptFeedbackUtility').getAllBookStatus();
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data && data.error && !bookStatus) {
        const notification = {
          open: true,
          message: data.error.message,
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    } else if (error.message === 'timeout of 60000ms exceeded') {
      const notification = {
        open: true,
        message: error.message,
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
    Framework.getStoreRegistry().getStore('chatgptFeedbackUtility').resetStoreValues();
  }
}
